export enum HttpType {
    post,
    get,
    delete,
    put,
}

export enum PopupType {
    none,
    fileEdit,
    ticketEdit,
    recipientEdit,
    recipientlistEdit,
    recipientlistDetails,
    recipientDetails,
    fileDetails,
    ticketDetails,
    genericText
}

export enum ErrorType {
    warning,
    error,
}

export enum ErrorLocationType {
    none,
    login,
    popup,
    table,
    form,
    guest
}

export enum PreferenceType {
    filter = 1,
    hiddenColumn = 2,
    general = 3,
    columnOrder
}

export enum SsoType {
    none,
    oauth,
    saml
}

export enum TableType {
    file,
    ticket,
    recipient,
    recipientlist
}

export enum TicketType {
    download,
    upload,
    staticDownload,
}

export enum ValidationStateType {
    none,
    processing,
    valid,
    invalid
}

export enum OverlayType {
    temporary,
    progress
}

export enum FileStatus {
    pending,
    uploading,
    completed,
    failed,
    deleted
}

export enum TicketStatus {
    active,
    expired,
    used,
    attemptsExhausted
}

export enum UploadStatus {
    initializing,
    uploading,
    paused,
    completed,
    failed,
    cancelled
}

export enum FileFilterCriteria {
    id,
    downloadToken,
    fileName,
    fileNamePattern,
    ownerId,
    fileType,
    uploadTicketId,
    status,
    createdDate,
    scheduledForDeletion,
    uploadSessionId
}

export enum RecipientFilterCriteria {
    id,
    email,
    emailPattern,
    firstName,
    lastName,
    fullName,
    ownerId
}

export enum RecipientListFilterCriteria {
    id,
    name,
    namePattern,
    ownerId,
    descriptionPattern,
    containsRecipient,
    createdDate
}

export enum TicketFilterCriteria {
    id,
    creatorUserId,
    recipientEmail,
    type,
    status,
    urlToken,
    fileId,
    createdDate,
    expirationDate,
    creatorUserId_Type,
    recipientEmail_Type,
    creatorUserId_Status
}
